/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import { Map, Record } from 'immutable';

export interface StreamState extends Map<string, any> {

    usersLoading: boolean,
    usersLoaded: boolean,
    usersFailed: boolean,
    userList: Array<any>;

    categoryListLoading: boolean;
    categoryListLoaded: boolean;
    categoryList: Array<any>;

    addProductLoading: boolean;
    addProductLoaded: boolean;
    addProductFailed: boolean;
    addProduct: any;

    addStreamLoading: boolean;
    addStreamLoaded: boolean;
    addStreamFailed: boolean;
    addStream: any;

    streamListLoading: boolean;
    streamList: Array<any>;

    streamLoading: boolean;
    stream: any;
}

export const streamrecord = Record({

    usersLoading: false,
    usersLoaded: false,
    usersFailed: false,
    userList: [],

    categoryListLoading: false,
    categoryListLoaded: false,
    categoryList: [],

    addProductLoading: false,
    addProductLoaded: false,
    addProductFailed: false,
    addProduct: {},

    addStreamLoading: false,
    addStreamLoaded: false,
    addStreamFailed: false,
    addStream: [],

    streamListLoading: false,
    streamList: [],

    streamLoading: false,
    stream: [],
});
